export const getChartModeTypes = batches =>
  (batches?.length ?? 0) > 12 ? ['brespondents'] : ['respondents', 'brespondents']

export const getDefaultChartMode = ({ chartMode, modelChartMode, globalChartMode, batches }) => {
  let mode = chartMode === 'off' ? globalChartMode : chartMode
  mode = mode || modelChartMode || globalChartMode

  if ((batches?.length ?? 0) > 12) return 'brespondents'

  if (['pie', 'percents'].includes(mode)) return 'respondents'
  if (mode === 'bpercents') return 'brespondents'

  return mode
}
